// extracted by mini-css-extract-plugin
export var content = "_n9-1";
export var fullScreen = "_n9-0";